<template>
  <CNav>
    <CNavItem v-for="item in destinations" :key="item.to">
      <CNavLink :href="item.to" :active="isActive(item)">
        <CIcon :icon="item.icon" />
        <span :class="labelClass">{{ item.label }}</span>
      </CNavLink>
    </CNavItem>
  </CNav>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { ALL, tenantOf } from '@/libraries/route'

interface Destination {
  label: string
  icon: string
  to: string
  match: string
}

/* Rendered twice, in the header on wide screens and as the bottom bar on phones:
 * CSS at the call sites picks which one shows. */
export default defineComponent({
  name: 'AppNav',
  props: {
    stacked: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return { route: useRoute() }
  },
  computed: {
    tenant(): string {
      return tenantOf(this.route)
    },
    labelClass(): string {
      return this.stacked ? '' : 'ms-2 d-none d-lg-inline'
    },
    destinations(): Destination[] {
      return [
        { label: 'Dashboard', icon: 'cil-speedometer', to: '#/dashboard', match: '/dashboard' },
        {
          label: 'Devices',
          icon: 'cil-devices',
          to: `#/tenant/${this.tenant}/device`,
          match: '/device',
        },
        /* Shown only inside a customer: otherwise "Devices" is already this link. */
        ...(this.tenant === ALL
          ? []
          : [
            {
              label: 'All devices',
              icon: 'cil-globe-alt',
              to: `#/tenant/${ALL}/device`,
              match: `/tenant/${ALL}/device`,
            },
          ]),
        {
          label: 'Accounts',
          icon: 'cil-vector',
          to: `#/tenant/${this.tenant}/account/ssh`,
          match: '/account',
        },
        {
          label: 'Triage',
          icon: 'cil-shield-alt',
          to: `#/tenant/${this.tenant}/triage`,
          match: '/triage',
        },
      ]
    },
  },
  methods: {
    isActive(item: Destination): boolean {
      return item.match === '/device'
        ? this.route.path.endsWith('/device')
        : this.route.path.includes(item.match)
    },
  },
})
</script>
